<template>
    <div style="width: 1200px;margin: 100px auto; color: #dddd; min-height: calc(100vh - 200px)">
        <el-button style="margin-left: 900px;" type="" icon="el-icon-document" @click="handleDownload">
        成绩导出
      </el-button>
        <el-tabs type="card" v-model="currentTab" @tab-click="handleClick" style="position: center;font-size: 30px;">
      <el-tab-pane :label="item.name"  v-for="(item,index) in lists" :name="index" style="height: auto;background: #ff751d; font-size: 70px;">
      </el-tab-pane>
        </el-tabs>
        <el-table ref="multipleTable" @selection-change="handleSelectionChange"  :data="list"  size="mini" fit element-loading-text="拼命加载中" border
                  highlight-current-row align="center" >
            <el-table-column type="selection" align="center"/>
            <el-table-column label="课程名称" prop="className" align="center"></el-table-column>
            <el-table-column label="学习成绩" prop="videoScore" align="center">
                <template slot-scope="scope">
                    {{scope.row.videoScore / 100}}
                </template>
            </el-table-column>
            <el-table-column label="练习成绩" prop="practiceScore" align="center">
                <template slot-scope="scope">
                    {{scope.row.practiceScore / 100}}
                </template>
            </el-table-column>
            <el-table-column label="考试成绩" prop="examScore" align="center">
                <template slot-scope="scope">
                    {{scope.row.examScore / 100}}
                </template>
            </el-table-column>
            <el-table-column label="答疑成绩" prop="answerScore" align="center">
                <template slot-scope="scope">
                    {{scope.row.answerScore / 100}}
                </template>
            </el-table-column>
            <el-table-column label="总成绩" prop="allScore" align="center">
                <template slot-scope="scope">
                    {{scope.row.allScore / 100}}
                </template>
            </el-table-column>
            <!--          <el-table-column label="是否通过" prop="isPass" align="center"></el-table-column>-->
        </el-table>
  </div>

</template>
<script>
import {myScore} from "../../assets/js/api.js";
import store from 'store'

export default {
  data() {
    return {
        currentTab: "",
        lists: [],
        list:[],
        downloadLoading:false,
        listLoading: true,
        multipleSelection: [],
        tableData: [],
        tableHeader: [],

    };
  },
    // mounted() {
    //   this.getScore()
    // },
created(){
  this.getScore()
},
  methods: {
    getScore(){
        myScore(localStorage.getItem("siteId"), localStorage.getItem("info")).then(res =>{
            this.lists = res.data
            console.log(this.lists)
            res.data.forEach(term => {
                if ((term.beginTime * 1000 <= new Date().getTime()) && (term.endTime * 1000 >= new Date().getTime())) {
                    this.list = term.terms;
                    this.currentTab = term.name

                }else {
                  this.list = term.terms;
                  this.currentTab = term.name
                }
            })
        })
    },
      handleClick(data) {
      this.lists.forEach(e =>{
          if (e.name == data.label) {
              this.list = e.terms
              console.log(e.terms, "成绩查询")
              this.listLoading = false;

          }
      })
      },
      handleSelectionChange(val) {
          this.multipleSelection = val
      },
      handleDownload() {
          if (this.multipleSelection.length) {
              import('@/vendor/Export2Excel').then(excel => {
                  const tHeader = ['课程名称', '学习成绩','练习成绩','考试成绩', '答疑成绩','总成绩']
                  const filterVal = ['className', 'videoScore', 'practiceScore', 'examScore','answerScore','allScore']
                  const list = this.multipleSelection
                  const data = this.formatJson(filterVal, list)
                  console.log(data, "考试成绩下载")
                  excel.export_json_to_excel({
                      header: tHeader,
                      data,
                      filename: '成绩导出'
                  })
                  this.$refs.multipleTable.clearSelection()
                  this.downloadLoading = false
              })
          } else {
              this.$message({
                  message: '请至少选择一行',
                  type: 'warning'
              })
          }
      },

      formatJson(filterVal, jsonData) {
          return jsonData.map(v => filterVal.map(j => {
              if (j.includes('Score')) {
                  console.log(v[j])
                  return v[j] / 100
              } else {
                  console.log(j, "shuju")

                  return v[j]
              }
          }))
      },


  }
};
</script>

